module.exports = __webpack_public_path__ + "img/arrow-down.ffd23e4d.svg";